import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import {
  ActionResultModel,
  BaseConfirmPromptComponent,
  ConfirmPromptAbstractComponent,
} from "@merchant-webapp/components";
import { EdModalRef } from "@edenred/components/modals";
import { TranslocoPipe } from "@jsverse/transloco";

const i18Cmp = "invoice_digital_consent.confirm_switching_prompt";

@Component({
  selector: "er-switch-digital-invoice-confirm-prompt",
  templateUrl: "./switch-digital-invoice-confirm-prompt.component.html",
  imports: [TranslocoPipe, BaseConfirmPromptComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SwitchDigitalInvoiceConfirmPromptComponent extends ConfirmPromptAbstractComponent {
  public readonly i18Cmp = i18Cmp;

  public constructor(@Inject(EdModalRef) modalRef: EdModalRef<unknown>) {
    super(modalRef);
  }

  protected onConfirmAction(): ActionResultModel {
    return { closePrompt: true, result: true };
  }

  protected onCloseAction(): ActionResultModel {
    return { closePrompt: true, result: false };
  }
}
